<template>
  <loading-placeholder :lines="12" class="entity-settings-loading" />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'EntitySettingsLoading',
})
</script>
